import { directDownload } from "@/utils/download-helper";
import Axios from "axios";
import { ActionTree } from "vuex";
import { RootState } from "../../types";
import { CallCenterUserItem, CallCenterUserFilter, CallCenterUsersState } from "./types";

export const actions: ActionTree<CallCenterUsersState, RootState> = {
  getCallCenterUsers: ({ commit }, data) => {
    // commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({ url: "/acapi/call_center_users", params: data })
        .then((resp) => {
          if (data?.page_number > 1) {
            commit("pushCallCenterUsers", resp.data.call_center_users);
          } else {
            commit('setCallCenterUsers', resp.data.call_center_users);
          }
          resolve(resp.data.call_center_users);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  getCallCenterUserItem: ({ commit }, id) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({ url: `/acapi/call_center_users/${id}` })
        .then((resp: any) => {
          let partnerUserItem = <CallCenterUserItem>resp.data;
          partnerUserItem.id = id;
          commit("setCallCenterUserItem", partnerUserItem);
          resolve(partnerUserItem);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  saveCallCenterUserItem: ({ commit, dispatch }, data: CallCenterUserItem) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({
        method: data.id ? "put" : "post",
        url: "/acapi/call_center_users/" + (data.id ?? ""),
        data: data,
      })
        .then((resp: any) => {
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  deleteCallCenterUserItem: ({ commit, dispatch }, data: CallCenterUserItem) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({
        method: "delete",
        url: `/acapi/call_center_users/${data.id}`,
        data: data,
      })
        .then((resp: any) => {
          dispatch("getCallCenterUsers");
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  resetPasswordCallCenter: ({ commit }, data: any) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      Axios({
        method: "post",
        url: `/acapi/call_center_users/password_link`,
        data: data,
      })
        .then((resp: any) => {
          resolve(resp);
        })
        .catch((err: any) => {
          reject(err);
        })
        .finally(() => commit("setLoading", false));
    });
  },
  exportCallCenterUsers({}, data: CallCenterUserFilter) {
    return directDownload("/acapi/call_center_users/export", data);
  },
};
